import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
              <i className="ri-book-open-line text-white text-lg"></i>
            </div>
            <span className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Ludo English
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              Home
            </Link>
            <Link
              to="/learn"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/learn') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              Learn English
            </Link>
            <Link
              to="/lessons"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/lessons') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              Private Lessons
            </Link>
            <Link
              to="/progress"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/progress') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              My Progress
            </Link>
            <Link
              to="/about"
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              About Me
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link
              to="/learn"
              className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Start Learning
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/') ? 'text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/learn"
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/learn') ? 'text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Learn English
              </Link>
              <Link
                to="/lessons"
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/lessons') ? 'text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Private Lessons
              </Link>
              <Link
                to="/progress"
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/progress') ? 'text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                My Progress
              </Link>
              <Link
                to="/about"
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/about') ? 'text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                About Me
              </Link>
              <Link
                to="/learn"
                className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors text-center whitespace-nowrap cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Start Learning
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
